/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontProductTile_user$ref = any;
export type StorefrontProductTile_user = {
    readonly serviceId: string | null;
    readonly " $refType": StorefrontProductTile_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontProductTile_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '32609aab90ed10c6bdcfe0b4525e0027';
export default node;
